export default "__VITE_ASSET__7b120d09__"